module.exports = __webpack_public_path__ + "static/media/finpos_lg.5655f65b.png";